module.exports = __webpack_public_path__ + "img/banner1.c1119b34.png";